// src/lecture/lectureApi.js
// API calls for Lecture Mode

import { apiService } from "../apiService";

export async function extractLectureTopics(formData) {
  return apiService.makeRequest("/api/lecture/extract-topics", {
    method: "POST",
    body: formData,
  });
}

export async function createLectureSession(title, topics, videoJobs) {
  const body = { title, topics };
  if (videoJobs) body.video_jobs = videoJobs;
  return apiService.makeRequest("/api/lecture/sessions", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function listLectureSessions() {
  return apiService.makeRequest("/api/lecture/sessions");
}

export async function getLectureSession(sessionId) {
  return apiService.makeRequest(`/api/lecture/sessions/${sessionId}`);
}

export async function updateLectureSession(sessionId, updates) {
  return apiService.makeRequest(`/api/lecture/sessions/${sessionId}`, {
    method: "PATCH",
    body: JSON.stringify(updates),
  });
}

export async function deleteLectureSession(sessionId) {
  return apiService.makeRequest(`/api/lecture/sessions/${sessionId}`, {
    method: "DELETE",
  });
}

export async function lectureChat(topicText, message, conversationHistory = []) {
  return apiService.makeRequest("/api/lecture/chat", {
    method: "POST",
    body: JSON.stringify({
      topic_text: topicText,
      message,
      conversation_history: conversationHistory,
    }),
  });
}
